import type { CSSProperties } from "react";
import { NavLink, Outlet, useLocation } from "react-router-dom";
import { useWorkspace } from "../features/workspace-context";

export function AppShell() {
  const { data, mode, signOut } = useWorkspace();
  const location = useLocation();
  if (!data) return null;

  return (
    <div className="app-shell">
      <aside className="sidebar">
        <NavLink className="brand" to="/" aria-label="Eremos Project Dashboard">
          <span className="brand__mark">E</span>
          <span>
            <strong>EREMOS</strong>
            <small>PROJECT COMMAND</small>
          </span>
        </NavLink>

        <nav className="sidebar__nav" aria-label="Proyectos">
          <span className="sidebar__label">Proyectos</span>
          {data.projects.map((project) => (
            <NavLink
              key={project.id}
              to={`/projects/${project.id}/overview`}
              className={({ isActive }) => `project-link${isActive ? " project-link--active" : ""}`}
              style={{ "--project-accent": project.accent } as CSSProperties}
            >
              <span className="project-link__orb" />
              <span>
                <strong>{project.name}</strong>
                <small>
                  {project.status === "active"
                    ? "Activo"
                    : project.status === "paused"
                      ? "Pausado"
                      : "Archivado"}
                </small>
              </span>
            </NavLink>
          ))}
        </nav>

        <div className="sidebar__footer">
          <NavLink className="sidebar-action" to="/profile">
            <span className="avatar avatar--small">
              {data.currentProfile.displayName.slice(0, 1).toUpperCase()}
            </span>
            <span>
              <strong>{data.currentProfile.displayName}</strong>
              <small>@{data.currentProfile.handle}</small>
            </span>
          </NavLink>
          <button
            className="sidebar-action sidebar-action--button"
            type="button"
            onClick={() => void signOut()}
          >
            <span aria-hidden="true">↪</span>
            <span>Cerrar sesión</span>
          </button>
        </div>
      </aside>

      <div className="app-shell__main">
        <header className="topbar">
          <div>
            <span className="eyebrow">Trazabilidad multi-proyecto</span>
            <p>
              {location.pathname === "/" ? "Portafolio EremosHub" : "Control operativo y evidencia"}
            </p>
          </div>
          <div className="topbar__actions">
            {mode === "demo" && <span className="mode-pill">Modo demo local</span>}
            <NavLink className="button button--secondary button--small" to="/">
              Portafolio
            </NavLink>
          </div>
        </header>
        <main className="content">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
